import * as yup from 'yup';
import moment from 'moment';

export function generateYupSchemaForDate(props) {
  let rules = props.rules;
  const getNextDate = moment().add(1, 'days');
  let yupSchema = yup.string();

  function isValidDate(message) {
    return this.test('isValidDate', message, function (value) {
      const { path, createError } = this;
      if (!value) {
        return createError({ path, message: message ?? 'Dit veld is verplicht.' });
      }

      // Validate date format: dd-mm-yyyy
      const dateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
      if (!dateRegex.test(value)) {
        return createError({ path, message: message ?? 'De datum moet in het formaat dd-mm-jjjj worden ingevoerd.' });
      }

      // Parse date using moment with explicit locale
      moment.locale('nl'); // Set Dutch or relevant locale if needed
      const dateObject = moment(value, 'DD-MM-YYYY', true); // Enforce strict parsing
      const minDate = moment('01-01-1890', 'DD-MM-YYYY');
      const maxDate = getNextDate; // Already a moment.js object

      if (!dateObject.isValid()) {
        return createError({ path, message: message ?? 'Ongeldige datum ingevoerd.' });
      }

      if (dateObject.isBefore(minDate) || dateObject.isAfter(maxDate)) {
        return createError({
          path,
          message: message ?? `Datum moet tussen 01-01-1890 en ${maxDate.format('DD-MM-YYYY')} liggen.`
        });
      }

      return true;
    });
  }

  yup.addMethod(yup.mixed, 'isValidDate', isValidDate);

  if (rules.isDate) {
    yupSchema = yup.mixed().isValidDate();
  }

  return yupSchema;
}
